import { App } from 'vue'

/**
 * 注册全局mixin
 * @param app
 */
export function setupMixins(app: App) {
  app.mixin({})
}
